import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { UserDm } from "@/_models";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { UserService } from "@/_services";
import { take } from "rxjs/operators";

@Injectable({ providedIn: "root" })
export class CurrentUserResolver {
    constructor(private userService: UserService) {}
    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ):
        | Observable<UserDm.UserModel>
        | Promise<UserDm.UserModel>
        | UserDm.UserModel {
        return this.userService.getCurrentUserAsync().pipe(take(1));
    }
}
